module.exports = __webpack_public_path__ + "7d088296/img/share-icon.0f8a11b4.svg";